import OfflineErrorIcon from 'assets/images/icons/offline-icon.webp';
import {useNavigate} from 'react-router-dom';
import {Button, Modal} from 'letrus-ui';
import styles from './GeneralErrorModal.module.scss';

export interface GeneralErrorModalProps {
  id: string;
  title?: string;
  description?: string;
  subTitle?: string;
  showIcon?: boolean;
}

function GeneralErrorModal({
  id,
  title,
  description,
  subTitle,
  showIcon,
}: GeneralErrorModalProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <Modal id={id}>
      <div className={styles.container} data-testid="error-modal">
        {showIcon && <img alt="Ícone de Erro" src={OfflineErrorIcon} />}
        <strong data-testid="custom-title">{title}</strong>
        <strong data-testid="custom-subTitle">{subTitle}</strong>
        <p
          data-testid="custom-description"
          dangerouslySetInnerHTML={{__html: description || ''}}
        />
        <div className={styles.buttonBack}>
          <Button onClick={() => navigate('/')}>Voltar</Button>
        </div>
      </div>
    </Modal>
  );
}

export default GeneralErrorModal;
